/* v15: price clarity in the buy box */
(function () {
  var root = document.querySelector('#buy'); if (!root) return;
  var json = document.querySelector('[data-ws-json]'); if (!json) return;
  var data; try { data = JSON.parse(json.textContent); } catch (e) { return; }
  var one = data.variants[0]; if (!one) return;
  function money(c) { return '£' + (c / 100).toFixed(2); }
  function isSub() { var b = root.querySelector('[data-ws-mode="sub"]'); return !!(b && b.getAttribute('aria-pressed') === 'true'); }
  var btn = root.querySelector('#ws-form [type="submit"]');
  var was = null;
  if (btn) {
    var tot = btn.querySelector('[data-ws-total]');
    if (tot) { was = document.createElement('s'); was.className = 'ws-atc-was'; tot.parentNode.insertBefore(was, tot); }
  }
  function sync() {
    var sub = isSub();
    var on = 0;
    root.querySelectorAll('[data-ws-bundle]').forEach(function (b, i) {
      var v = data.variants[i]; if (!v) return;
      if (b.classList.contains('is-on')) on = i;
      var price = (sub && v.planPrice) ? v.planPrice : v.price, full = one.price * v.qty;
      var p = b.querySelector('.ws-b__p');
      if (p) p.innerHTML = '<strong>' + money(price) + '</strong>' + (full > price ? '<s>' + money(full) + '</s>' : '');
      var s = b.querySelector('.ws-b__save');
      if (s) { if (full > price) { s.hidden = false; s.textContent = 'Save ' + money(full - price); } else { s.hidden = true; } }
    });
    if (was) {
      var v = data.variants[on], price = (sub && v.planPrice) ? v.planPrice : v.price, full = one.price * v.qty;
      was.textContent = full > price ? money(full) : '';
    }
  }
  sync();
  new MutationObserver(sync).observe(root, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-pressed'] });
})();
